import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var FaceOkSVG = function FaceOkSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M16,2A14,14,0,1,1,2,16,14,14,0,0,1,16,2Zm4.52,17.5H10.88a1,1,0,0,0,.12,2h9.63a1,1,0,0,0-.11-2ZM12,11a2,2,0,1,0,2,2A2,2,0,0,0,12,11Zm8,0a2,2,0,1,0,2,2A2,2,0,0,0,20,11Z"
  }));
};
FaceOkSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(FaceOkSVG);